module.exports = __webpack_public_path__ + "img/f6s.7244055f.png";